<template>
    <span :class="{'position-relative d-block': changeable}">
        <template v-if="isEmptyTrigger">
            <v-popover popoverInnerClass="p-2">
                <span class="param empty">When it happens </span>
                <template v-slot:popover="{ isOpen }">
                    <multiselect
                        v-if="isOpen"
                        :options="availableTriggers"
                        @input="onTriggerSelect"
                        label="label"
                        trackBy="value"
                        autofocus
                        class="trigger-select"/>
                </template>
            </v-popover>
        </template>
        <template v-else>
            <template v-if="trigger.code === AutomationTriggerCodes.SCHEDULE">
                <AppSchedulerPopover
                    :value="schedulerConfig"
                    @update="onSchedulerConfigChange">
                    <template v-slot:trigger>
                        <AppSchedulerSentence :config="schedulerConfig" class="param selected"/>
                    </template>
                </AppSchedulerPopover>
            </template>
            <template v-else>
                <span>
                    When {{ triggerLabel }}
                </span>
            </template>
        </template>
        <slot name="after-trigger"></slot>
    </span>
</template>

<script>
import {AutomationTypes} from '@/types/automations/types'
import AppSchedulerPopover from '../../shared/schedule-picker/AppSchedulerPopover'
import AppSchedulerSentence from '../../shared/schedule-picker/AppSchedulerSentence'
import {automationEventTriggersList} from '@/components/automation/trigger/index'
import {getAppSchedulerDefaultConfig} from '@/components/shared/schedule-picker'
import {AutomationTriggerCodes, AutomationTriggers} from '@/types/automations'
import {getAutomationTriggerDisplayValue} from '@/components/automation/display-value'

export default {
    name: 'AutomationEditorTrigger',
    components: {AppSchedulerSentence, AppSchedulerPopover},
    props: {
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        },
        trigger: { // AutomationTrigger
            type: Object,
            required: true
        },
        changeable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            AutomationTriggers,
            AutomationTriggerCodes
        }
    },
    computed: {
        isEmptyTrigger() {
            return !this.trigger.code
        },

        availableTriggers() {
            return automationEventTriggersList.map(trigger => ({...trigger, label: _.capitalize(trigger.label)}))
        },

        schedulerConfig() {
            return this.trigger.schedulerConfig
        },

        sentence() {
            return {
                template: this.trigger.name
            }
        },

        triggerLabel() {
            return getAutomationTriggerDisplayValue(this.trigger)
        }
    },
    methods: {
        onTriggerSelect(trigger) {
            const data = {
                code: trigger.value,
                enabled: true
            }
            if (data.code === AutomationTriggerCodes.SCHEDULE) {
                data.schedulerConfig = getAppSchedulerDefaultConfig()
            }
            this.$emit('change', {path: [], data})
        },

        onSchedulerConfigChange(schedulerConfig) {
            this.$emit('change', {path: ['schedulerConfig'], data: _.cloneDeep(schedulerConfig)})
        }
    }
}
</script>

<style scoped lang="scss">
@import '../index';
</style>

<style lang="scss">
.trigger-select {
    min-width: 360px;
}
</style>
